<div class="au-dialog-container">
	<h2 class="au-dialog-title">{{ data.header || ('confirm_action' | translate) }}</h2>
	<mat-icon mat-dialog-close matRipple class="close-icon">close</mat-icon>
	<div class="au-dialog-content">
		<!-- prettier-ignore -->
		<p class="au-dialog-description" [innerHTML]="data.actionDescription"></p>
	</div>
</div>
<mat-dialog-actions class="actions-row">
	<button mat-button mat-dialog-close>{{ 'cancel' | translate }}</button>
	<button matRipple mat-flat-button (click)="actionApproved()">
		{{ (data.confirmButton | translate) || ('ok' | translate | uppercase) }}
	</button>
</mat-dialog-actions>
